module.exports = __webpack_public_path__ + "img/image-thumb-23.d9e640fc.webp";